<template>
    <ds-status
        class="status-label"
        :data-qa="`${broadcastSubject}-status`"
        :emphasis="broadcastStatusEmphasis"
        :type="broadcastStatusType"
    >
        {{ broadcastStatusMessage }}
    </ds-status>
</template>

<script>
import {
    BROADCAST_STATUS,
    MESSAGE_CONSTANTS,
    STATUS_EMPHASIS,
    STATUS_TYPE,
} from '@/components/broadcast/constants/emailBroadcast.constants.js';

export default {
    MESSAGE_CONSTANTS,

    props: {
        broadcast: {
            type: Object,
            required: true,
        },
    },

    computed: {
        broadcastStatusEmphasis() {
            const { status } = this.broadcast;

            return (!status || status === BROADCAST_STATUS.ERROR)
                ? STATUS_EMPHASIS.HIGH
                : STATUS_EMPHASIS.LOW;
        },

        broadcastStatusMessage() {
            const { status } = this.broadcast;

            return MESSAGE_CONSTANTS.STATUS_CHIP[status] || MESSAGE_CONSTANTS.STATUS_CHIP.Draft;
        },

        broadcastStatusType() {
            const { status } = this.broadcast;
            const {
                CANCELLED,
                DONE,
                ERROR,
                PROCESSING,
                QUEUED,
                SCHEDULING,
            } = BROADCAST_STATUS;

            if (status == null) {
                return STATUS_TYPE.DEFAULT;
            }

            if ([SCHEDULING, QUEUED, PROCESSING, CANCELLED].includes(status)) {
                return STATUS_TYPE.WARNING;
            }

            if (status === DONE) {
                return STATUS_TYPE.GOOD;
            }

            if (status === ERROR) {
                return STATUS_TYPE.ERROR;
            }

            return null;
        },

        broadcastSubject() {
            return this.broadcast.subject || MESSAGE_CONSTANTS.NO_SUBJECT;
        },
    },
};
</script>
